import { memo, FC } from 'react'
import {
  // Select,
  InputGroup,
  // InputLeftAddon,
  Input,
} from '@chakra-ui/react'

import { DynamicFieldProps } from '../..'

const NumberFilterField: FC<DynamicFieldProps> = ({
  name,
  register,
}) => {
  return (
    <InputGroup width="100%" minWidth="min-content">
      {/* <InputLeftAddon p={0} width="max-content">
        <Select placeholder="Selecione uma regra" roundedRight="none" {...register(`${name}_rule`)}>
          <option value="GREATER_THAN">Maior que</option>
          <option value="LOWER_THAN">Menor que</option>
          <option value="EQUAL">Igual a</option>
        </Select>
      </InputLeftAddon> */}

      <Input {...register(name)} type="number" inputMode="numeric" />
    </InputGroup>
  )
}

export default memo(NumberFilterField)
